<template>
  <BaseDialog
    :visible="visible"
    :title="displayText.title"
    width="670px"
    :close-on-click-modal="false"
    @close="onClose"
    @confirm="onConfirm"
  >
    <BaseElForm ref="formBusinessRef" :model="localFormData" :rules="formRules" label-position="top">
      <BaseElFormItem :label="displayText.allClosed">
        <el-switch v-model="localFormData.allClosed" :active-text="$t('common.open.text')" :inactive-text="$t('common.close.text')" />
      </BaseElFormItem>
      <p class="content mb-[20px]">{{ displayText.subtitle }}</p>
      <BaseElFormItem v-if="showControl.alExcludeTimeRules" :label="displayText.allExcludeTimeRules" prop="allExcludeTimeRules">
        <AddPeriodTimes :excludeTimeRule="localFormData.allExcludeTimeRules" :omitList="['weekly']" />
      </BaseElFormItem>
    </BaseElForm>
  </BaseDialog>
</template>

<script>
import { defineComponent, ref, onMounted, computed } from 'vue'
import BaseDialog from '@/components/Dialog/BaseDialog.vue'
import AddPeriodTimes from '@/components/AddPeriodTimes.vue'
import formUtils from '@/utils/form'
import { cloneDeep, get } from 'lodash'

export default defineComponent({
  name: 'AllStoreSettingsDialog',
  components: { BaseDialog, AddPeriodTimes },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    formRules: {
      type: Object,
      required: true,
    },
  },
  emits: ['close', 'confirm'],
  setup (props, { emit }) {
    const formBusinessRef = ref(null)
    const localFormData = ref({})
    const displayText = computed(() => {
      const data = {
        title: '全店公休',
        subtitle: '若開啟門市模組，所設定的全店公休時段會套用至所有門市。',
        allClosed: '全店公休',
        allExcludeTimeRules: '全店公休時段',
      }
      return data
    })
    const showControl = computed(() => {
      const controls = {
        alExcludeTimeRules: get(localFormData.value, 'allClosed'),
      }
      return controls
    })
    const onClose = () => {
      emit('close')
    }

    const onConfirm = async () => {
      const valid = await formUtils.checkForm(formBusinessRef.value)
      if (valid) {
        emit('confirm', localFormData.value)
      }
    }
    onMounted(() => {
      localFormData.value = cloneDeep(props.formData)
    })
    return {
      formBusinessRef,
      localFormData,
      onClose,
      onConfirm,
      displayText,
      showControl,
    }
  },
})
</script>

<style scoped>
</style>
